import { AbstractReportPmsApiService } from '../abstract-report.service';
import { FinancialTransactionReport } from '../../../models/reports/financial/transactions-report.model';

/**
 * @class SecurityDepositPmsApiService
 * @extends {AbstractReportPmsApiService<FinancialTransactionReport>}
 */
export class SecurityDepositPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/financial/security-deposit';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {FinancialTransactionReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new FinancialTransactionReport(attributes);
    }

    newTransactionCollection(paginationData, ...params) {

        let to = paginationData.from - 1;

        const models = Object.values(paginationData.data).map(groups => {

            to += groups.items.length;

            return {
                'total_row': groups.total_row,
                'items': groups.items.map(attributes => this.newModel(attributes, ...params))
            };
        });

        return {
            reservation: paginationData.reservation,
            total_row: paginationData.total_row,
            all_total_row: paginationData.all_total_row,
            perPage: paginationData.per_page,
            page: paginationData.current_page,
            total: paginationData.total,
            from: paginationData.from,
            payment_voucher_prefix: paginationData.payment_voucher_prefix,
            receipt_voucher_prefix: paginationData.receipt_voucher_prefix,
            to: to,
            models: models
        };
    }

    /**
     * @param {...*} params
     * @return {function(response: Object): PaginationCollection<M>}
     * @protected
     */
    getTransactionCollector(...params) {

        return (response) => {

            const responseData = this.extractData(response);

            if (responseData.data && Array.isArray(responseData.data)) {

                responseData.data = {
                    group: {
                        items: responseData.data
                    }
                };
            }

            return this.newTransactionCollection(responseData, ...params);
        };
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getTransactionCollector())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/financial/security-deposit.service.js